import { useCallback } from 'react';
import { ListSubheader, MenuItem, Select } from '@mui/material';
import {
  SUPPLIER_STATUS_CONTROL,
  SUPPLIER_STATUS_DONOTUSE,
  SUPPLIER_STATUS_GROW,
  SUPPLIER_STATUS_LIMITED_USE,
  SUPPLIER_STATUS_MAINTAIN,
  SUPPLIER_STATUS_REDUCE
} from '../../shared/AppConstants';

export default function StatusEdit(props) {
  const { id, field, value, api } = props;

  const handleChange = useCallback(
    (event) => {
      api.setEditCellValue({ id, field, value: event.target.value }, event);
      api.stopCellEditMode({ id, field });
    },
    [api, field, id]
  );

  return (
    <Select defaultOpen={true} value={value} onChange={handleChange}>
      <ListSubheader>Strategic Status</ListSubheader>
      <MenuItem value={SUPPLIER_STATUS_GROW}>
        &nbsp;&nbsp;&nbsp;{SUPPLIER_STATUS_GROW}
      </MenuItem>
      <MenuItem value={SUPPLIER_STATUS_MAINTAIN}>
        &nbsp;&nbsp;&nbsp;{SUPPLIER_STATUS_MAINTAIN}
      </MenuItem>
      <MenuItem value={SUPPLIER_STATUS_CONTROL}>
        &nbsp;&nbsp;&nbsp;{SUPPLIER_STATUS_CONTROL}
      </MenuItem>
      <ListSubheader>Non-Strategic Status</ListSubheader>
      <MenuItem value={SUPPLIER_STATUS_LIMITED_USE}>
        &nbsp;&nbsp;&nbsp;{SUPPLIER_STATUS_LIMITED_USE}
      </MenuItem>
      <MenuItem value={SUPPLIER_STATUS_REDUCE}>
        &nbsp;&nbsp;&nbsp;{SUPPLIER_STATUS_REDUCE}
      </MenuItem>
      <MenuItem value={SUPPLIER_STATUS_DONOTUSE}>
        &nbsp;&nbsp;&nbsp;{SUPPLIER_STATUS_DONOTUSE}
      </MenuItem>
    </Select>
  );
}
